import React, { type FC } from 'react'
import { useAtom } from 'jotai'
import { PageHeader } from 'mailup-web-components'
import { useIntl } from 'react-intl'
import { useNavigate } from 'react-router-dom'
import { pageState } from 'State/page'
import { originalFilterAtom } from '../state/state'
import SaveButton from './SaveButton'

const Header: FC = () => {
  const intl = useIntl()
  const navigate = useNavigate()
  const [{ status }] = useAtom(pageState)
  const [{ Id, Name }] = useAtom(originalFilterAtom)
  const breadcrumbLbl =
    Id !== 0
      ? intl.formatMessage({ id: 'Load.CombinedFilterForm.EditFilter' })
      : intl.formatMessage({ id: 'Load.FiltersList.AddFilter' })

  const title =
    Id !== 0 ? Name : intl.formatMessage({ id: 'Load.FiltersList.AddFilter' })

  const breadcrumbsItems = [
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.Recipients' }),
      'data-mu-test': 'breadcrumb-item__recipients',
      onClick: Function.prototype,
    },
    {
      label: intl.formatMessage({ id: 'Load.NavMenu.RecipientsFilters' }),
      'data-mu-test': 'breadcrumb-item__filters',
      url: '#',
      onClick: () => {
        navigate('/filters/list')
      },
    },
    {
      label: breadcrumbLbl,
      'data-mu-test': 'breadcrumb-item__add-edit',
      onClick: Function.prototype,
    },
  ]

  const ControlsComponent = (): React.JSX.Element | null => {
    return status === 'ready' || status === 'fetching' ? <SaveButton /> : null
  }

  return (
    <PageHeader
      title={title}
      breadcrumbsItems={breadcrumbsItems}
      ControlsComponent={ControlsComponent}
    />
  )
}

export default Header
